import { React } from 'react';
import { withStyles } from '@material-ui/core';
import FindProfessionals from '../../../../../components/FindProfessionals';
import PageLayout from '../../../../../components/layouts/WithHeader';
import useDesktop from '../../../../../hooks/useDesktop';
import style from './style';

const FindProfessional = ({ classes }) => {
  const isDesktop = useDesktop();

  return (
    <>
      <PageLayout
        minFullHeight
        lessMarginLeft={isDesktop}
        maxWidth="lg"
        hideHeader={isDesktop}
        headerTitle="Finn håndverker"
        className={classes.findProfessionalHeader}
        noPaddingTop
      >
        <FindProfessionals />
      </PageLayout>
    </>
  );
};

export default withStyles(style)(FindProfessional);
